var render = function render(){var _vm=this,_c=_vm._self._c;return _c('e-dialog',{attrs:{"dialog-title":"查看原因","center-dialog-visible":_vm.reasonVisible,"popup-width":'560px',"close-btn":"","modal-append-to-body":false},on:{"resetPopupData":_vm.reasonCancel}},[_c('div',[_vm._v(_vm._s(_vm.refuseReasons))])])
}
var staticRenderFns = []

export { render, staticRenderFns }